import {
  SendUsAnEmailForm as EmailForm,
  type SendUsAnEmailFormProps,
  LightCard,
} from '@stripe-internal/conversations-ui';

export function SendUsAnEmailForm(props: SendUsAnEmailFormProps) {
  return (
    <LightCard isOuter>
      <EmailForm {...props} />
    </LightCard>
  );
}
